import styled from "styled-components"
import Text from "./Text"
const RequiredText = styled(Text)`
  &:after {
    content: '*';
    color: #FB4EFF;
  }
`

export default RequiredText;